(() => {
  const initAtlasHeroV53 = (root) => {
    if (!root || root.dataset.atlasV53Initialized === 'true') return;
    root.dataset.atlasV53Initialized = 'true';

    const button = root.querySelector('.atlas-hero-v5__primary-button');
    if (!button) return;

    button.addEventListener('click', (event) => {
      const href = button.getAttribute('href') || '';
      if (!href.startsWith('#')) return;

      const target = document.querySelector(href);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  const initAll = () => {
    document.querySelectorAll('.atlas-hero-v5').forEach(initAtlasHeroV53);
  };

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.atlas-hero-v5') || event.target;
    if (section?.classList?.contains('atlas-hero-v5')) {
      section.dataset.atlasV53Initialized = 'false';
      initAtlasHeroV53(section);
    }
  });
})();